module.exports = __webpack_public_path__ + "img/ccompany-honor-TPD-20231219.e7d63f49.jpg";